import { setupForDark } from '@theme';
import classNames from 'classnames';

export default function EntityName({
  name,
  size = 'large'
}: {
  name: string;
  size?: 'large' | 'small';
}) {
  let classes = 'A2M mb-[4px]';
  if (size === 'small') {
    classes = 'L2M';
  }

  return <div className={classNames(classes, setupForDark('text-tertiary'))}>{name}</div>;
}
